import { AirportCodes } from '../../../../types/airports';
import { UrlMapping } from '../../../../types/urlMapping';

export type AirportCodesWithParkingBooking =
	| AirportCodes.IAH
	| AirportCodes.HOU;

export const airportParkingBookingRoute: UrlMapping<AirportCodesWithParkingBooking> =
	{
		[AirportCodes.IAH]: {
			url: 'https://iah.booking.fly2houston.com/book/IAH/Parking',
		},
		[AirportCodes.HOU]: {
			url: 'https://hou.booking.fly2houston.com/book/HOU/Parking',
		},
	};
